
import { createContext } from 'react';
import { ConfirmMethod } from '../../components/ConfirmDialog';

export default createContext<ConfirmMethod>(()=>Promise.resolve(false));
